<template>
	<sf-modal-layout size="x" :title="title" :show="show" :closeModal="close">
		<div class="user-managment-items-container">
			<div>hihi</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="close">{{ getMessage_('MWCC000343') }}</sf-button>
			<sf-button :onClick="openModal">modal</sf-button>
		</template>
		<popup-view-two ref="popupView2" :popup2="popup2" />
	</sf-modal-layout>
</template>

<script>
import PopupViewTwo from './PopupViewTwo.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GridFreeForm/store/helpers';
export default {
	props: { isOpen: { type: Boolean, default: false } },
	components: {
		PopupViewTwo
	},
	data() {
		return {
			show: this.isOpen,
			param: '',
			popup2: false
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('MWCC000414');
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;
			this.param = param;
		},
		close() {
			this.show = false;
		},
		openModal() {
			this.popup2 = true;
			this.$refs.popupView2.open();
		}
	}
};
</script>

<style scoped>
.user-managment-items-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
